import React, {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useFirestore} from 'react-redux-firebase'
import {Table, Popup, Icon, Label, Loader, Menu, Button, Placeholder} from 'semantic-ui-react'
import * as SportradarActions from '../../../actions/SportradarActions'
import * as moment from 'moment'

export function Leaguetable(props) {
    const firestore = useFirestore();
    const dispatch = useDispatch();

    const match = useSelector((state) => 
        (state.sportradar.getIn(['match', 'id']) === props.id)?
            state.sportradar.get('match').toJS()
        :null
    );

    const leaguetables = useSelector((state) =>  (
            (match === null) || 
            (state.sportradar.get('leaguetables') === null) ||
            state.sportradar.getIn(['leaguetables', 'sport']) !== match.sport.id || 
            state.sportradar.getIn(['leaguetables', 'category']) !== match.category.id || 
            state.sportradar.getIn(['leaguetables', 'tournament']) !== match.tournament.id || 
            state.sportradar.getIn(['leaguetables', 'season']) !== match.season.id
        ) ? null : state.sportradar.get('leaguetables').toJS());

    useEffect(() => {
        if(match === null)
            dispatch(SportradarActions.load_match(firestore, props.id));
        else if(match !== null)
            dispatch(SportradarActions.load_leaguetables(firestore, match.sport.id, match.category.id, match.tournament.id, match.season.id));
    }, [props.id, match === null])

    return (
        <div style={{
            overflow: 'auto',
            height: '100%'
        }}>
        {
            (leaguetables === null)?
                <Loader inline active />
            :
                <div>Tabellen
                    <pre>
                    {
                        JSON.stringify(leaguetables, null, 2)
                    }
                    </pre>
                </div>
        }
        </div>
    )
}